<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>بيانات الفرع</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                      <form role='form'>
                      <div class='modal-body'>
                        <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                          <ul v-if='validationErrors'>
                              <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                          </ul>
                        </div>
                        <div class='alert alert-success alert-dismissable' v-if='successShow'>
                           {{success}}
                        </div>
                        <fieldset>
                              <input v-model='record.id' name='id' type='text' hidden>

                              <div class='form-group col-lg-6 col-sm-6'>
                                  <label>اسم الفرع:</label>
                                  <input v-model='record.name' class='form-control' name='name' type='text'>
                              </div>
                              <div class='form-group col-lg-6 col-sm-6'>
                                  <label>الاسم التجارى:</label>
                                  <input v-model='record.trade_name' class='form-control' name='name' type='text'>
                              </div>
                              <div class='form-group col-lg-6 col-sm-6'>
                                  <label>المدير:</label>
                                  <input v-model='record.manager' class='form-control' name='manager' type='text'>
                              </div>
                              <div class='form-group col-lg-6 col-sm-6'>
                                  <label>التليفون:</label>
                                  <input v-model='record.phone' class='form-control' name='phone' type='text'>
                              </div>
                              <div class='form-group col-lg-12 col-sm-12'>
                                  <label>العنوان:</label>
                                  <input v-model='record.address' class='form-control' name='address' type='text'>
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>السجل التجارى:</label>
                                <input style="text-align:center" v-model="record.tax_record" class="form-control" name="tax_record" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>البطاقة الضريبية:</label>
                                <input style="text-align:center" v-model="record.tax_card" class="form-control" name="tax_card" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>عنوان الفاتورة:</label>
                                <input style="text-align:center" v-model="record.Invoice_header" class="form-control" name="Invoice_header" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>الـIP:</label>
                                <input style="text-align:center" v-model="record.ip" class="form-control" name="Invoice_header" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>معامل الطباعة X:</label>
                                <input style="text-align:center" v-model="record.x_rate" class="form-control" name="Invoice_header" type="text">
                              </div>
                              <div class="form-group col-lg-3 col-sm-6">
                                <label>معامل الطباعة Y:</label>
                                <input style="text-align:center" v-model="record.y_rate" class="form-control" name="Invoice_header" type="text">
                              </div>
                              <div class='form-group col-lg-3 col-sm-6'>
                              <label>نوع الورق</label>
                              <select class="form-control" style="padding: 0px" v-model="record.paper_size">
                                <option v-for="item in paperSize" v-bind:key="item.id" v-bind:value="item.id">
                                  {{ item.name}}
                                </option>
                              </select>
                            </div>
                            <div class="form-group col-lg-6 col-sm-6">
                              <label>وقت بداية العمل فى الفرع:</label>
                              <input style="text-align:center" v-model="record.start_time" class="form-control" name="Invoice_header" type="text">
                            </div>
                            <div class="form-group col-lg-6 col-sm-6">
                              <label>وقت نهاية العمل فى الفرع:</label>
                              <input style="text-align:center" v-model="record.end_time" class="form-control" name="Invoice_header" type="text">
                            </div>
                            </fieldset>
                        </div>
                        <div class='modal-footer'>
                            <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                            <button v-show="$per.value.saveBranch" @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                                  <div class='col-lg-3 col-sm-3' style='padding:0px'>
                                    <download-excel :data='testRecords'>
                                    <button type='button' class='btn btn-outline btn-default btn-sm ' style='padding:2px;width: 60px'>
                                      <b><i class='fa fa-table'></i> تصدير </b>
                                    </button>
                                    </download-excel>
                                  </div>
                            <button v-show="$per.value.saveBranch" @click='testData' type='button' class='btn btn-primary'>all</button>
                        </div>
                      </form>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Branche',
  data () {
    return {
      paperSize: [
        {id: 0, name: 'صغير'},
        {id: 1, name: 'كبير'}
      ],
      validationErrors: '',
      record: {},
      testRecords: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false
    }
  },
  created () {
    this.GetData()
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getBranch', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.record = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    testData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'test', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.testRecords = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveBranch', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        name: this.record.name,
        trade_name: this.record.trade_name,
        manager: this.record.manager,
        phone: this.record.phone,
        address: this.record.address,
        tax_record: this.record.tax_record,
        tax_card: this.record.tax_card,
        ip: this.record.ip,
        x_rate: this.record.x_rate,
        y_rate: this.record.y_rate,
        Invoice_header: this.record.Invoice_header,
        paper_size: this.record.paper_size,
        start_time: this.record.start_time,
        end_time: this.record.end_time
      })
        .then(res => {
          this.isLoadingSave = false
          this.success = 'تم الحفظ بنجاح'
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/company/Branch.vue